import { Content } from "../../squidex";

export class ArticleTypeModel extends Content {
    constructor(current?: Content) {
        super(current);
    }
}
